import { createFileRoute } from "@tanstack/react-router";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { AdminAccessGate } from "@/components/admin-access-gate";
import { GpsDriveSessionBanner } from "@/components/gpsdrive-session-banner";

export const Route = createFileRoute("/admin/fleet-management")({
  component: () => (
    <AdminAccessGate action="notificacoes">
      <FleetManagementAdminPage />
    </AdminAccessGate>
  ),
  head: () => ({ meta: [{ title: "Gestão de Frota — Administração — Wp Rastreamento" }] }),
});

function FleetManagementAdminPage() {
  return (
    <div className="space-y-6 p-6">
      <div>
        <h1 className="text-2xl font-bold tracking-tight">Gestão de Frota</h1>
        <p className="text-sm text-muted-foreground">Módulo de gestão de frota da empresa.</p>
      </div>

      <GpsDriveSessionBanner />

      <Card>
        <CardHeader>
          <div className="flex items-center gap-2">
            <CardTitle className="text-base">Em breve</CardTitle>
            <Badge variant="secondary">Em breve</Badge>
          </div>
          <CardDescription>Este módulo ainda está em desenvolvimento.</CardDescription>
        </CardHeader>
        <CardContent />
      </Card>
    </div>
  );
}
